import { modalBlogEventPush, modalBlogNewEventPush } from "./components/modalEventPush";
import modalSpinner from "./components/modalSpinner";

export default function setBlogSubscribeModalHandlers(wpcfModalSelector){
    let wpcFSubscribeSentModalSelector  = $(wpcfModalSelector);

    let wpcfSubscribeNativeSelector     = document.querySelector( '.card-chat .wpcf7' );
    let wpcfFormSubscribeNativeSelector = wpcfSubscribeNativeSelector ? wpcfSubscribeNativeSelector.querySelector('form') : null;
    if(!wpcfFormSubscribeNativeSelector) return;
    let $wpcf = $('.card-chat .wpcf7');
    let $subscribeBlockEvent= $('.card-chat-wrapp.card-right').data('gtm-event');
    let $buttonText = $wpcf.find('button[type=submit] span').text();

    let successTitle     = wpcFSubscribeSentModalSelector.data('success-title');
    let successMessage   = wpcFSubscribeSentModalSelector.data('success-message');
    let failTitle       = wpcFSubscribeSentModalSelector.data('fail-title');
    let failMessage = wpcFSubscribeSentModalSelector.data('fail-message');


    function responseModal(status){
        let responseModalIcon   = wpcFSubscribeSentModalSelector.find('.wrapp-icon span');
        let responseModalTitle  = wpcFSubscribeSentModalSelector.find('.modal-title');
        let responseModalDesc   = wpcFSubscribeSentModalSelector.find('.message');
        
        responseModalIcon.addClass(status ? 'icon-success' : 'icon-erorr');
        responseModalTitle.text(status ? successTitle : failTitle);
        responseModalDesc.text(status ? successMessage : failMessage);

        wpcFSubscribeSentModalSelector.modal('show');

        wpcFSubscribeSentModalSelector.on('hide.bs.modal', function () {
            responseModalIcon.removeClass(status ? 'icon-success' : 'icon-erorr');
            responseModalTitle.text('');
            responseModalDesc.text('');
        })
    }

    $wpcf.find('button').on('click', function (){
        modalBlogEventPush('Сlick Subscribe Newsletters', 'Form Subscription');
        dataLayer.push({
            'event':'EOSCOM', 
            'eventCategory':'EosComEvents', 
            'eventAction':'subscription_button', 
            'eventLabel': 'ready_section', 
            'eventContent':'', 
            'eventPosition':$subscribeBlockEvent ? $subscribeBlockEvent : '', 
            'eventContext': $buttonText ? $buttonText : ''
        });
    })

    wpcFSubscribeSentModalSelector.on('hide.bs.modal', function() {
        $(wpcfFormSubscribeNativeSelector).find('.form-field').removeClass('not-empty');
        wpcfFormSubscribeNativeSelector.reset();
    });

    wpcfFormSubscribeNativeSelector.addEventListener( 'submit', function() {
        modalBlogNewEventPush('subscription_submit', 'ready_section', $buttonText);
        modalSpinner($wpcf , 'start');
    }, false );

    wpcfSubscribeNativeSelector.addEventListener( 'wpcf7mailsent', function() {
        modalBlogEventPush('Show Suсcess Newsletter Subscription', 'Form Subscription');
        modalBlogNewEventPush('subscription_success', 'ready_section', $buttonText);
        wpcFSubscribeSentModalSelector.modal('show');
        modalSpinner($wpcf , 'stop');
        responseModal(true);
    }, false );
    
    wpcfSubscribeNativeSelector.addEventListener( 'wpcf7mailfailed', function() {
        modalBlogEventPush('Show Error Newsletter Subscription', 'Form Subscription');
        modalBlogNewEventPush('subscription_error', 'ready_section', $buttonText);
        wpcFSubscribeSentModalSelector.modal('show');
        modalSpinner( $wpcf , 'stop');
        responseModal(false);
    }, false );

    wpcfSubscribeNativeSelector.addEventListener( 'wpcf7spam', function() {
        modalBlogEventPush('Show Error Newsletter Subscription', 'Form Subscription');
        modalBlogNewEventPush('subscription_error', 'ready_section', $buttonText);
        wpcFSubscribeSentModalSelector.modal('show');
        modalSpinner( $wpcf , 'stop');
        responseModal(false);
    }, false );

    wpcfSubscribeNativeSelector.addEventListener( 'wpcf7invalid', function() {
        modalBlogEventPush('Show Error Newsletter Subscription', 'Form Subscription');
        modalBlogNewEventPush('subscription_error', 'ready_section', $buttonText);
        modalSpinner( $wpcf , 'stop');
    }, false );
}
